import { Box, Button, Img, SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import '../Styles/Contact.css'
import { FaGithub, FaLinkedin, FaMailBulk, FaMobileAlt, FaRocket } from 'react-icons/fa';
const Contact = () => {
  return (
    <Box className='contact_main'>

      <Box className='contact_banner'>
        {/* <h1>Contact Me</h1> */}
      </Box>
      <Box className="contact_details">
         <SimpleGrid columns={[1,1,2,3]} spacing={20}>
          {/* Email */}
           <Box className='contact_item'>
            <Box className='contact_img'>
              {/* <Img src="https://cdn.icon-icons.com/icons2/1826/PNG/512/4202011emailgmaillogomailsocialsocialmedia-115677_115624.png" alt="email" /> */}
              <FaMailBulk size="60px" color="#d88cff"/>
            </Box>
            <Box className="contact_text">
              aniketbansaldev@gmail.com
            </Box>
            </Box> 
            {/* Phone */}
            <Box className='contact_item'>
            <Box className='contact_img'>
            <FaMobileAlt size="60px" color="#d88cff"/>
            </Box>
            <Box className="contact_text">
              +91 9958855047
            </Box>
            </Box> 
            {/* GitHub */}
            <Box className='contact_item'>
            <a href="https://github.com/Aniket-bansal" target="_blank" rel="noreferrer">
            <Box className='contact_img'>
              <FaGithub size="60px" color="#d88cff"/>
            </Box>
            <Box className="contact_text">
              Aniket-bansal
            </Box>
            </a>
            </Box> 
            {/* Linkedin */}
            <Box className='contact_item'>
            <a href="https://www.linkedin.com/in/aniket-bansal-dev/" target="_blank" rel="noreferrer">
            <Box className='contact_img'>
              {/* <Img src="https://cdn.icon-icons.com/icons2/2037/PNG/512/in_linked_linkedin_media_social_icon_124259.png" alt="linkedin" /> */}
              <FaLinkedin size="60px" color="#d88cff"/>
            </Box>
            <Box className="contact_text">
           Aniket Bansal
            </Box>
            </a>
            </Box> 
            {/* resume */}
            <Box className='contact_item'>
            <a href="./Aniket_Bansal_Resume.pdf" download>
            <Box className='contact_img'>
            <FaRocket size="60px" color="#d88cff" />
            </Box>
            <Box className="contact_text">
            Resume
            </Box>
            </a>
            </Box> 
         </SimpleGrid>
      </Box>
    </Box>
  )
}

export default Contact